import { PackPage } from '@rhg/components/pack-page';
import PageTitle from '@rhg/components/page-title';
import discoverMessages from '@rhg/lang/messages/discover';
import withAuth from '@rhg/libs/auth0/with-auth';
import { useRouter } from 'next/router';
import { useIntl } from 'react-intl';

const DiscoverPackPage = () => {
    const { formatMessage } = useIntl();
    const { query } = useRouter();
    const packClass =
        'packClass' in query && typeof query.packClass === 'string'
            ? query.packClass
            : undefined;
    const viewAll =
        'viewAll' in query && typeof query.viewAll === 'string'
            ? query.viewAll
            : undefined;

    return (
        <>
            <PageTitle
                title={formatMessage(discoverMessages['discover.title'])}
            />
            <PackPage packClass={packClass} viewAll={viewAll} />
        </>
    );
};

export default withAuth(DiscoverPackPage);
